import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import AutoNumeric from 'autonumeric';
import { jsx as _jsx } from "react/jsx-runtime";

var ReactNumeric = function (_React$Component) {
  _inherits(ReactNumeric, _React$Component);

  var _super = _createSuper(ReactNumeric);

  function ReactNumeric(props) {
    var _this;

    _classCallCheck(this, ReactNumeric);

    _this = _super.call(this, props);
    _this.getValue = _this.getValue.bind(_assertThisInitialized(_this));
    _this.callEventHandler = _this.callEventHandler.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ReactNumeric, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.autonumeric = new AutoNumeric(this.input, this.props.value, _objectSpread(_objectSpread(_objectSpread({}, this.props.preDefined), this.props), {}, {
        onChange: undefined,
        onFocus: undefined,
        onBlur: undefined,
        onKeyPress: undefined,
        onKeyUp: undefined,
        onKeyDown: undefined,
        watchExternalChanges: false
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.autonumeric) this.autonumeric.remove();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var isOptionsChanged = JSON.stringify(_objectSpread(_objectSpread({}, this.props), {}, {
        value: undefined
      })) !== JSON.stringify(_objectSpread(_objectSpread({}, newProps), {}, {
        value: undefined
      }));
      var isValueChanged = this.props.value !== newProps.value && this.getValue() !== newProps.value;

      if (isValueChanged) {
        this.autonumeric.set(newProps.value);
      }

      if (isOptionsChanged) {
        this.autonumeric.update(_objectSpread(_objectSpread(_objectSpread({}, newProps.preDefined), newProps), {}, {
          onChange: undefined,
          onFocus: undefined,
          onBlur: undefined,
          onKeyPress: undefined,
          onKeyUp: undefined,
          onKeyDown: undefined,
          watchExternalChanges: false
        }));
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      if (!this.autonumeric) return;
      var valueMapper = {
        string: function string(numeric) {
          return numeric.getNumericString();
        },
        number: function number(numeric) {
          return numeric.getNumber();
        }
      };
      return valueMapper[this.props.outputFormat](this.autonumeric);
    }
  }, {
    key: "callEventHandler",
    value: function callEventHandler(event, eventName) {
      if (!this.props[eventName]) return;
      this.props[eventName](event, this.getValue());
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var inputProps = {};
      ['id', 'className', 'style', 'disabled', 'type', 'name', 'tabIndex', 'unselectable', 'size', 'autoFocus', 'placeholder'].forEach(function (prop) {
        return inputProps[prop] = _this2.props[prop];
      });
      return _jsx("input", _objectSpread({
        ref: function ref(_ref) {
          return _this2.input = _ref;
        },
        onChange: function onChange(e) {
          return _this2.callEventHandler(e, 'onChange');
        },
        onFocus: function onFocus(e) {
          return _this2.callEventHandler(e, 'onFocus');
        },
        onBlur: function onBlur(e) {
          return _this2.callEventHandler(e, 'onBlur');
        },
        onKeyPress: function onKeyPress(e) {
          return _this2.callEventHandler(e, 'onKeyPress');
        },
        onKeyUp: function onKeyUp(e) {
          return _this2.callEventHandler(e, 'onKeyUp');
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.callEventHandler(e, 'onKeyDown');
        },
        "data-value": this.props.value
      }, inputProps));
    }
  }]);

  return ReactNumeric;
}(React.Component);

export { ReactNumeric as default };
ReactNumeric.propTypes = {
  type: PropTypes.oneOf(['text', 'tel', 'hidden']),
  id: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  tabIndex: PropTypes.number,
  unselectable: PropTypes.bool,
  size: PropTypes.number,
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
  onKeyUp: PropTypes.func,
  onKeyDown: PropTypes.func,
  allowDecimalPadding: PropTypes.bool,
  caretPositionOnFocus: PropTypes.number,
  createLocalList: PropTypes.bool,
  currencySymbol: PropTypes.string,
  currencySymbolPlacement: PropTypes.string,
  decimalCharacter: PropTypes.string,
  decimalCharacterAlternative: PropTypes.string,
  decimalPlaces: PropTypes.number,
  decimalPlacesRawValue: PropTypes.number,
  decimalPlacesShownOnBlur: PropTypes.number,
  decimalPlacesShownOnFocus: PropTypes.number,
  defaultValueOverride: PropTypes.string,
  digitalGroupSpacing: PropTypes.string,
  digitGroupSeparator: PropTypes.string,
  divisorWhenUnfocused: PropTypes.number,
  emptyInputBehavior: PropTypes.oneOf(['null', 'focus', 'press', 'always', 'zero']),
  eventBubbles: PropTypes.bool,
  eventIsCancelable: PropTypes.bool,
  failOnUnknownOption: PropTypes.bool,
  formatOnPageLoad: PropTypes.bool,
  historySize: PropTypes.number,
  isCancellable: PropTypes.bool,
  leadingZero: PropTypes.oneOf(['allow', 'deny', 'keep']),
  maximumValue: PropTypes.string,
  minimumValue: PropTypes.string,
  modifyValueOnWheel: PropTypes.bool,
  negativeBracketsTypeOnBlur: PropTypes.string,
  negativePositiveSignPlacement: PropTypes.oneOf(['l', 'r', 'p', 's']),
  negativeSignCharacter: PropTypes.string,
  noEventListeners: PropTypes.bool,
  onInvalidPaste: PropTypes.oneOf(['error', 'ignore', 'clamp', 'truncate', 'replace']),
  outputFormat: PropTypes.oneOf(['string', 'number']),
  overrideMinMaxLimits: PropTypes.oneOf(['ceiling', 'floor', 'ignore']),
  positiveSignCharacter: PropTypes.string,
  rawValueDivisor: PropTypes.number,
  readOnly: PropTypes.bool,
  roundingMethod: PropTypes.string,
  saveValueToSessionStorage: PropTypes.bool,
  selectNumberOnly: PropTypes.bool,
  selectOnFocus: PropTypes.bool,
  serializeSpaces: PropTypes.string,
  showOnlyNumbersOnFocus: PropTypes.bool,
  showPositiveSign: PropTypes.bool,
  showWarnings: PropTypes.bool,
  styleRules: PropTypes.object,
  suffixText: PropTypes.string,
  symbolWhenUnfocused: PropTypes.string,
  unformatOnHover: PropTypes.bool,
  unformatOnSubmit: PropTypes.bool,
  valuesToStrings: PropTypes.object,
  wheelOn: PropTypes.oneOf(['focus', 'hover']),
  wheelStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  preDefined: PropTypes.object
};
ReactNumeric.defaultProps = {
  type: 'text',
  outputFormat: 'number',
  preDefined: {},
  className: 'asdf'
};
export var predefinedOptions = AutoNumeric.getPredefinedOptions();